import { actionCreators } from '../../../actions';
import getRelayEnvironment from '../../../relayClientEnvironment';
import { AUTO_PROMPT_REGISTER } from '../../../authModal/authentication/authFlowConstants';
import asyncAuth from '../../../authModal/async';

const onTradeApplicationPage = () => {
    const path = location.pathname;
    return path.split('/trade/apply').length > 1;
};

const deferred = () => {
    let resolveRef;

    const promise = new Promise(resolve => {
        resolveRef = resolve;
    });

    promise.resolve = resolveRef;
    return promise;
};

const postAuthDeferred = deferred();
let moduleLoaded = false;

const loadPostAuthModule = function () {
    if (!moduleLoaded) {
        asyncAuth().then(mod => {
            const relayEnv = getRelayEnvironment();
            const postAuth = mod;
            postAuth.init(relayEnv);
            postAuthDeferred.resolve(postAuth);
        }, 'authModal');
        moduleLoaded = true;
    }

    return postAuthDeferred;
};

export function autoPromptRegistration({ flow, launchOrigin }) {
    const { setUpdateUserState } = actionCreators;

    return new Promise(res => {
        if (onTradeApplicationPage()) {
            res(setUpdateUserState(false));
        }
        loadPostAuthModule().then(postAuth => {
            postAuth.run(AUTO_PROMPT_REGISTER, flow, launchOrigin).onUserChanged(() => {
                res(setUpdateUserState(true));
            });
        });
    });
}
